module.exports = __webpack_public_path__ + "img/1.58de61d8.png";